import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationTranssulphurationCombined from "./index";

const MethylationTranssulphurationWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationTranssulphurationCombined}
    keyControlsId="methylation-transsulphuration-key"
    {...props}
  />
);

export default MethylationTranssulphurationWithToggleKey;
